import React, { useContext, useState } from 'react'
import { store, actions } from '../../stores/multipost'
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Input, Label } from 'reactstrap'
import PreviewModal from "../graphics/PreviewModal"
import { Trash2 } from 'react-feather'
import { actionsForProvider } from './assetUtils'

export default function FileAsset({ file, asset, className }) {
  const { selectedAccounts, dispatch } = useContext(store)
  const [previewOpen, setPreviewOpen] = useState(false)

  // enabled actions on an asset might not be available if the given account has since been deselected
  const enabledActions = asset.enabledActions.filter(a => selectedAccounts.includes(a.provider))
  const availableActions = selectedAccounts.flatMap(provider => actionsForProvider(provider))

  const onRemove = (file, asset) => {
    if(file.assets.length == 1){
      dispatch({
        type: actions.REMOVE_FILE,
        file: file
      })
    }else{
      file.assets = file.assets.filter(a => a.key !== asset.key)
      dispatch({
        type: actions.REPLACE_FILE,
        file: file
      })
    }
  }

  const toggleAction = (key) => {
    if(asset.enabledActions.find(a => a.key === key)){
      asset.enabledActions = asset.enabledActions.filter(a => a.key !== key)
    }else{
      asset.enabledActions.push(availableActions.find(a => a.key === key))
    }

    dispatch({
      type: actions.REPLACE_FILE,
      file: file
    })
  }

  const enabledPostProviders  = enabledActions.filter((a) => !a.story).map((a) => a.provider)
  const enabledStoryProviders = enabledActions.filter((a) => a.story).map((a) => a.provider)

  const postInputs = ( enabledPostProviders.length > 0 &&
    <>
      <Input type="hidden" name="team_post[files][][id]" value={file.id} />
      <Input type="hidden" name="team_post[files][][type]" value={file.type} />
      <Input type="hidden" name="team_post[files][][story]" value={false} />
      { asset.format && <Input type="hidden" name="team_post[files][][format]" value={asset.format} />}
      {enabledPostProviders.map((provider, providerIndex) => (
        <Input key={providerIndex} type="hidden" name="team_post[files][][accounts][]" value={provider} />
      ))}
    </>
  )

  const storyInputs = ( enabledStoryProviders.length > 0 &&
    <>
      <Input type="hidden" name="team_post[files][][id]" value={file.id} />
      <Input type="hidden" name="team_post[files][][type]" value={file.type} />
      <Input type="hidden" name="team_post[files][][story]" value={true} />
      { asset.format && <Input type="hidden" name="team_post[files][][format]" value={asset.format} />}
      {enabledStoryProviders.map((provider, providerIndex) => (
        <Input key={providerIndex} type="hidden" name="team_post[files][][accounts][]" value={provider} />
      ))}
    </>
  )


  return (
    <div key={asset.key} className={`d-flex align-items-center justify-content-between p-3 ${className}`}>
      <div onClick={() => setPreviewOpen(true)} className="grow-on-hover cursor-pointer">
        <img
          style={{ maxHeight: '30px' }}
          alt={asset.name}
          src={asset.previewUrl}
          className="rounded-2"
        />
      </div>
      <div className="d-flex align-items-center">
        <div className="mx-2">
          {enabledActions.map(({ name }) => name).join(', ')}
          <span className="text-muted">{enabledActions.length == 0 && 'none selected'}</span>
        </div>
        <UncontrolledDropdown>
          <DropdownToggle size="md" color="outline-secondary" caret className="ps-2 rounded-2 py-1" />
          <DropdownMenu end className="mt-1 p-0">
            {availableActions.map(({ name, key }) => (
              <Label key={key} className="dropdown-item cursor-pointer d-flex align-items-center mb-0">
                <Input
                  type="checkbox"
                  checked={asset.enabledActions.map(a => a.key).includes(key)}
                  className="mt-0 me-2"
                  onClick={(e) => e.nativeEvent.stopImmediatePropagation()}
                  onChange={(e) => toggleAction(key)}
                />
                <span>{name}</span>
              </Label>
            ))}
            <DropdownItem onClick={() => onRemove(file, asset)} className="d-flex align-center gap-2 lh-sm dropdown-item--danger">
              <Trash2 size="16" />
              Remove
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
        {postInputs}
        {storyInputs}
      </div>
      {file.type == 'graphic' && (
        <PreviewModal
          graphic={file}
          isOpen={previewOpen}
          close={() => setPreviewOpen(false)}
          selectedFormat={asset.format}
        />)}

      {file.type == 'upload' && (
        <PreviewModal
          graphic={{
            attributes: {
              formats: [{
                id: "default",
                extension: asset.name.split('.').pop()
              }],
              full_urls: {
                default: file.attributes.full_url
              }
            }
          }}
          isOpen={previewOpen}
          close={() => setPreviewOpen(false)}
        />
      )}
    </div>
  )
}